import { Button, IconButton } from '@festina-life/ui/actions'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'
import type { ReactNode } from 'react'

export const FPlusCustomCollectionEditor = <TValue,>({
  currentValue,
  onChange,
  renderEditor,
  emptyValue,
}: {
  currentValue: TValue[]
  onChange: (nextValue: TValue[]) => void
  renderEditor: (value: TValue, index: number) => ReactNode
  emptyValue: TValue
}) => {
  const translate = useTranslate()

  return (
    <div className="flex flex-col gap-y-2 w-full">
      {currentValue.map((value, index) => (
        <div
          // oxlint-disable-next-line react/no-array-index-key
          key={index}
          className={cx(
            'flex flex-row gap-x-2 items-center p-1 rounded-md',
            paperStyles({ borders: ['all'], ringColor: 'grey' }),
          )}
        >
          {renderEditor(value, index)}
          <IconButton
            iconName="Trash"
            iconSize="sm"
            isDanger
            onClick={(evt) => {
              evt.stopPropagation()
              onChange(currentValue.toSpliced(index, 1))
            }}
          />
        </div>
      ))}
      <Button
        startIcon="Plus"
        onClick={(evt) => {
          evt.stopPropagation()

          onChange([...currentValue, emptyValue])
        }}
      >
        {translate('templateViewer.customEditor.addValue')}
      </Button>
    </div>
  )
}
